import React, { useEffect, useState } from "react";
import TextAreaField from "../../forms/textarea-field";
import InputField from "../../forms/input-field";
import { useDispatch } from "react-redux";
import SelectField from "../../forms/select-field";
import { stateListAction } from "../../../redux/actions/general-action";

const StoreDrugAddressTab = () => {
  const dispatch = useDispatch();

  const [stateList, setStateList] = useState([]);

  useEffect(() => {
    dispatch(stateListAction(onSuccessState, onErrorState));
  }, []);

  const onSuccessState = (data) => {
    setStateList(
      data.map((item) => {
        return { label: item?.name, value: item?.name };
      })
    );
  };
  const onErrorState = () => {};
  return (
    <div className="w-full 2xl:w-[30%] lg:w-[60%] px-5 xl:px-10">
      <TextAreaField
        label="Address "
        placeholder="Enter Address"
        name="dl_address"
        id={"dl_address"}
        // isRequired={true}
        labelWidth="8.5rem"
        feildHeight="5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_area"
        placeholder="Enter Area"
        label="Area"
        labelWidth="8.5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_landmark"
        placeholder="Enter Landmark"
        label="Landmark"
        labelWidth="8.5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_town_or_village"
        placeholder="Enter Town/ Village"
        label="Town/ Village"
        labelWidth="8.5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_city"
        placeholder="Enter City"
        label="City"
        labelWidth="8.5rem"
      />
      <SelectField
        placeholder={"Select state"}
        options={stateList}
        label={"Select State"}
        id={"dl_state"}
        name="dl_state"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        // isRequired={true}
        labelWidth="8.5rem"
      />

      <SelectField
        // isRequired={true}
        placeholder={"Select country"}
        options={countryList}
        label={"Country/Region"}
        id={"dl_country_region"}
        name="dl_country_region"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        labelWidth="8.5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_pin_code"
        placeholder="Enter Pincodde"
        label="Pin Code"
        labelWidth="8.5rem"
      />
    </div>
  );
};

export default StoreDrugAddressTab;

const countryList = [{ label: "India", value: "india" }];
